import { render, staticRenderFns } from "./ModalDadosNFExtrato.vue?vue&type=template&id=d9da65d4&scoped=true"
import script from "./ModalDadosNFExtrato.vue?vue&type=script&lang=ts"
export * from "./ModalDadosNFExtrato.vue?vue&type=script&lang=ts"
import style0 from "./ModalDadosNFExtrato.vue?vue&type=style&index=0&id=d9da65d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9da65d4",
  null
  
)

export default component.exports